import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { CMDSpGiftLogQueryTotal, ICommand } from '../../live';
import { AbstractHandler } from '..';
import { giftRecordSliceActions } from '@/modules/report/slice/giftRecord';

export class CMDSpGiftLogQueryTotalHandler extends AbstractHandler {
    _command: CMDSpGiftLogQueryTotal;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpGiftLogQueryTotal;
    }
    handle(dispatch: Dispatch<AnyAction>): void {
        dispatch(giftRecordSliceActions.updateTotal(this._command.TotalRow));
    }
}
